import { init } from '@emailjs/browser';

// Initialize EmailJS with public key
const emailPublicKey = process.env.REACT_APP_EMAIL_PUBLIC_KEY || process.env.EMAIL_PUBLIC_KEY;

if (emailPublicKey) {
  init(emailPublicKey);
  console.log("EmailJS initialized");
} else {
  console.warn("EmailJS public key missing - emails may not work properly");
}

export default {
  serviceId: process.env.REACT_APP_EMAIL_SERVICE_ID || process.env.EMAIL_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAIL_TEMPLATE_ID || process.env.EMAIL_TEMPLATE_ID,
  publicKey: emailPublicKey
}; 